import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { SupportModalBlockComponent } from '@lib/components/support-class';
import { CommonLibService } from '@lib/services';
import { SubTestPayload } from './sub-test.state';

@Component({
  selector: 'asw-hello-world-pres',
  templateUrl: './sub-test.component.html',
  styleUrls: ['./sub-test.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubTestComponent extends SupportModalBlockComponent implements OnInit {
  styleClass = 'height_1';

  public text = '';

  reload(): void {}
  init(): void {
    if (this.payload?.testFunc) {
      this.payload.testFunc();
    }
    this.text = this.payload?.text ?? '';
  }
  destroy(): void {}

  constructor(private _common: CommonLibService, @Inject(DOCUMENT) private _document: Document) {
    super(_common);
  }

  override payload: SubTestPayload | null = {};

  test1() {
    this.styleClass = 'height_1';
  }
  test2() {
    this.styleClass = 'height_2';
  }
  test3() {
    this.styleClass = 'height_3';
  }
  test4() {
    this.styleClass = 'height_4';
  }
  test5() {
    this.styleClass = 'height_5';
  }

  goScrollPoint() {
    const elem = this._document.getElementById(`scroll-point`);
    if (elem) {
      this.setScroll(elem.offsetTop - elem.offsetHeight / 2);
    }
  }
}
